<section class="hero" aria-labelledby="programme-hero-title">
  <p class="eyebrow">Embedded assessments for courses and programmes</p>
  <h1 class="display" id="programme-hero-title">Give Participants a Clear Way to Assess Their Progress</h1>
  <div class="wrap hero-grid">
    <div class="hero-copy">
      <p class="lead">
        Turn the skills and outcomes in your programme into visual self-assessment wheels — configured for your course and installed
        directly on your website.
      </p>
      <div class="hero-actions" aria-label="Programme assessment actions">
        <a
          class="button button--primary"
          [routerLink]="[]"
          fragment="enquiry"
          (click)="ctaClicked.emit('hero_primary')"
          data-testid="programme-hero-cta"
          >Discuss Your Assessment</a
        >
        <a
          class="button button--secondary"
          [routerLink]="[]"
          fragment="programme-example"
          (click)="ctaClicked.emit('hero_programme_example')"
          data-testid="programme-example-cta"
          >See a Programme Example</a
        >
      </div>
    </div>
    <figure class="product-visual" aria-labelledby="example-configuration-label">
      <div class="browser-frame">
        <div class="browser-frame__bar" aria-hidden="true"><span></span><span></span><span></span></div>
        <div class="client-page">
          <div class="client-page__header" aria-hidden="true">
            <span class="client-page__site-name">Leadership Essentials</span><span>Programme</span><span>Resources</span>
          </div>
          <div class="client-page__intro">
            <span class="client-page__kicker">Module 4 reflection</span>
            <h2>Delegation Skills Assessment</h2>
            <p>Rate where your practice is today using the guidance for each category.</p>
          </div>
          <div class="embedded-assessment">
            <div class="hero-img"><img src="assets/delegation.jpg" alt="Wheel of Life for Delegations Skill set" /></div>
            <div class="assessment-categories" aria-hidden="true">
              <span><i class="assessment-categories__swatch assessment-categories__swatch--one"></i>Clear outcomes <b>7</b></span>
              <span><i class="assessment-categories__swatch assessment-categories__swatch--two"></i>Feedback <b>8</b></span>
              <span><i class="assessment-categories__swatch assessment-categories__swatch--three"></i>Support <b>5</b></span>
              <span><i class="assessment-categories__swatch assessment-categories__swatch--four"></i>Autonomy <b>8</b></span>
            </div>
          </div>
        </div>
      </div>
    </figure>
  </div>
</section>
